<div class="card">
    <slot></slot>
</div>

<style>
    .card {
        background-color: white;
        border-radius: 6px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        padding: 20px;
    }
</style>